import { Component, inject } from "@angular/core";
import {
  AsyncPipe,
  DecimalPipe,
  JsonPipe,
  KeyValuePipe,
} from "@angular/common";
import { MatCardContent, MatCardModule } from "@angular/material/card";
import { ApiService } from "../../../../../shared/src";
import { MatChip, MatChipSet } from "@angular/material/chips";
import { FeatureFlagDirective } from "../../../../../shared/src/lib/directives/feature-flag.directive";
import { MatExpansionModule } from "@angular/material/expansion";

@Component({
    selector: "app-api-call-duration",
    imports: [
        AsyncPipe,
        MatCardModule,
        MatCardContent,
        JsonPipe,
        KeyValuePipe,
        MatChipSet,
        MatChip,
        DecimalPipe,
        FeatureFlagDirective,
        MatExpansionModule,
    ],
    templateUrl: "./api-call-duration.component.html",
    styleUrl: "./api-call-duration.component.scss"
})
export class ApiCallDurationComponent {
  apiService = inject(ApiService);
  expanded = false;

  handleExpansion(event: MouseEvent) {
    event.preventDefault();
    if (event.shiftKey) {
      this.expanded = !this.expanded;
    }
  }
}
